var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaultTable',{ref:"tableList",on:{"handlePreview":_vm.handlePreview}})}
var staticRenderFns = []

export { render, staticRenderFns }